<template>
  <el-dialog
    append-to-body
    v-model="dialogVisible"
    width="400px"
    @close="handleClose"
    destroy-on-close
    class="refuse-dialog-container"
  >
    <template #header>
      <header>
        <el-icon size="24px" color="#0052D9"><WarningFilled /></el-icon>
        <div>拒绝原因</div>
      </header>
    </template>

    <el-radio-group v-model="cancelReason" class="reasonList">
      <el-radio
        v-for="(reason, index) in reasons"
        :key="index"
        v-model="reason.value"
        :label="reason.label"
        :name="String(index)"
        size="large"
      />
    </el-radio-group>
    <el-input
      :style="{ visibility: selectedOther ? 'visible' : 'hidden' }"
      v-model="otherReason"
      placeholder="请输入拒绝原因"
    />

    <template #footer>
      <el-popconfirm
        @confirm="refuseReserve"
        width="220"
        confirm-button-text="确定"
        cancel-button-text="取消"
        icon-color="#626AEF"
        title="你是否确定拒绝该预订?"
        z-index="9999"
      >
        <template #reference>
          <el-button color="#0052D9">确认</el-button>
        </template>
      </el-popconfirm>
    </template>
  </el-dialog>
</template>
<script lang="ts" setup>
import { ElMessage } from "element-plus"
import { reactive, ref, watch } from "vue"
import { updateCustomerTableReservation } from "@/api/business/table"

const emit = defineEmits(["update:show", "refresh", 'reject'])

const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
  customerReserveId: {
    type: Number,
    required: true,
  },
})
const dialogVisible = ref(false)
const reasons = reactive([
  //
  {
    label: "客户需求不符合",
    value: true,
  },
  {
    label: "无法满足客户要求",
    value: false,
  },
  {
    label: "时间冲突",
    value: false,
  },
  {
    label: "其它",
    value: false,
  },
])
const selectedOther = ref(false)
const otherReason = ref("")
const cancelReason = ref()

watch(
  () => props.show,
  (newVal) => {
    dialogVisible.value = newVal
  },
  {
    immediate: true,
  },
)
watch(
  () => cancelReason.value,
  (newVal) => {
    if (newVal === "其它") {
      selectedOther.value = true
    } else {
      selectedOther.value = false
    }
  },
)
const handleClose = () => {
  dialogVisible.value = false
  emit("update:show", false)
}
const refuseReserve = () => {
  if (!cancelReason.value) {
    ElMessage.error("请选择拒绝原因")
    return
  }
  if (cancelReason.value === "其它" && !otherReason.value) {
    ElMessage.error("请输入拒绝原因")
    return
  }
  console.log("refuseReserve", props.customerReserveId)
  updateCustomerTableReservation({
    status: 4,
    customerReserveId: props.customerReserveId,
    cancelReason: cancelReason.value,
  })
    .then((res) => {
      if (res.code === 0 && res.data) {
        ElMessage.success("已拒绝预订")
        emit("refresh")
        emit("reject")
        handleClose()
      } else {
        ElMessage.error("发生错误")
      }
    })
    .catch(() => {
      ElMessage.error("发生错误")
    })
}
</script>

<style scoped lang="scss">
.refuse-dialog-container {
  header {
    display: flex;
    gap: 10px;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
    color: var(--tea-color-text-primary);

    el-icon {
      margin-right: 10px;
    }
  }

  .reasonList {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .el-checkbox {
      margin-bottom: 10px;
    }
  }
}
</style>
